import React, { useEffect, useReducer, useState } from "react"
import { obterBrindesFornecedor } from "../../../services/brindesFornecedor"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { BrindesFornecedorActionsTypes } from "./brindesFornecedorActions"
import { BrindesFornecedorContext } from "./BrindesFornecedorContext"
import { BrindesFornecedorInicial, brindesFornecedorReducer } from "./brindesFornecedorReducer"

export function BrindesFornecedorContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(brindesFornecedorReducer, BrindesFornecedorInicial)
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterBrindesFornecedor(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar promoções")
            } else {
                setErroCarregamento(null)
                dispatch({ type: BrindesFornecedorActionsTypes.CARREGAR, payload: response })
            }
        } catch {
            setErroCarregamento("Erro ao carregar promoções")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
    }, [])

    return (
        <BrindesFornecedorContext.Provider value={{ dados, dispatch, erroCarregamento }}>
            <Loading />
            {children}
        </BrindesFornecedorContext.Provider>
    )
}
